import { Box, Stack, styled } from "@mui/material";

export const PollChipButton = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isActive" && prop !== "isDisabled",
})<{ isActive: boolean; isDisabled?: boolean }>(
    ({ isActive, isDisabled = false }) => ({
        WebkitTapHighlightColor: "transparent",
        display: "flex",
        cursor: "pointer",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        width: "max-content",
        minWidth: "56px",
        justifyContent: "center",
        textWrap: "nowrap",
        height: "32px",
        borderRadius: "90px",
        padding: "0 12px",
        backgroundColor: isActive
            ? "var(--community-color-primary-text)"
            : !isDisabled
            ? "var(--community-color-transparent-black-05)"
            : "var(--community-color-transparent-black-disabled)",
        "& > svg": {
            width: "16px",
            height: "16px",
            color: isActive
                ? "var(--community-color-snow-white)"
                : !isDisabled
                ? "var(--community-color-primary-text)"
                : "var(--community-color-transparent-black-disabled)",
        },
        "& > p": {
            fontSize: "14px",
            fontWeight: "500",
            color: isActive
                ? "var(--community-color-snow-white)"
                : !isDisabled
                ? "var(--community-color-primary-text)"
                : "var(--community-color-transparent-black-50)",
        },
    }),
);

export const PollTabStack = styled(Stack)({
    gap: "12px",
});

export const PollTabSectionStack = styled(Stack)({
    gap: "8px",
});

export const RatePollSliderContainer = styled(Box)({
    aspectRatio: "unset",
    minHeight: "128px",
    padding: "24px 0",
    borderRadius: "4px",
    background: `url(${process.env.REACT_APP_CDN_ENDPOINT}/external/tippspiel/media/backgroundSliderPoll.webp)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
});
